<template>

  <Modal v-if="visible" :value="true" @input="closeModal">
    <h3 slot="header">Excluir usuário</h3>

    <div class="row text-align-center">
      <div class="col-md-12">
        <p>Deseja realmente excluir usuário {{ user.name || user.email }}?</p>
        <button class="btn btn-outline-red btn-md mr-2" @click="$emit('deleteUser', user)">Excluir</button>
        <button class="btn btn-outline btn-md mr-2" @click="closeModal">Agora não</button>
      </div>
    </div>

  </Modal>

</template>

<script>
  import Modal from '../shares/specialTag/Modal'

  export default {
    components: { Modal },
    computed: {
      visible() {
        return this.user && this.value
      }
    },
    data() {
      return {
        load: false
      }
    },
    methods: {
      closeModal() {
        this.$emit('input', false)
      }
    },
    name: 'ModalDeleteUser',
    props: {
      user: { required: true, type: Object },
      value: { default: false, type: Boolean }
    }
  }
</script>

<style scoped>

</style>
